// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { getDoctag, getGudang, getProses } from '../../../api/helper';
import appInfo from '../../../configs/app-info';

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
    MenuItem
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { useToast } from '../../../components/ToastProvider'
import DialogDP from '../../../components/acc/DialogDP'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    // ** State
    const [tabs, setTabs] = useState<string>("0")

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [valDoctagInv, setValDoctagInv] = useState<any>(null)
    const [sdsoD, setSdsoD] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])
    const [listDoctagInv, setListDoctagInv] = useState<any[]>([])
    const [sddo, setSddo] = useState<any>(null)

    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogInv, setOpenDialogInv] = useState<boolean>(false)
    const [mode, setMode] = useState<string>('')

    const [openDialogDP, setOpenDialogDP] = useState<boolean>(false)
    const [dialogMode, setDialogMode] = useState<string>('add')
    const [selectedData, setSelectedData] = useState<any>(null)

    useEffect(() => {
        const fetchDoctag = async () => {
            const response = await getDoctag(appInfo.menuId.do, cabang, token);
            setListDoctag(response);
        };

        const fetchDoctagInv = async () => {
            const response = await getDoctag(appInfo.menuId.invoice, cabang, token);
            setListDoctagInv(response);
        };

        getData(tabs)
        fetchDoctag();
        fetchDoctagInv();
    }, [])

    const navigate = useNavigate();

    const getData = (mode: any) => {
        setListData([])
        let url = apiUrl.apiUrl + '/sales/delivery-order/list'

        axios
            .get(url, {
                params: {
                    awal: tglAwal,
                    akhir: tglAkhir,
                    mode: mode,
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const getDetail = (id: any) => {

        let url = apiUrl.apiUrl + '/acc/dp-customer/detail/' + id

        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    setDialogMode('edit')
                    setSelectedData(data)
                    setOpenDialogDP(true)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/sales/delivery-order/delete/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getData(tabs)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const handleChangeTabs = (event: SyntheticEvent, newValue: string) => {
        setTabs(newValue)
        getData(newValue)
    }

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Cetak Delivery Order",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/sales/delivery-order/pdf/' + row.id, '_blank')
            },
            {
                title: "Cetak Delivery Order Rangkap",
                icon: "mdi:printer",
                color: "primary",
                onClick: () => window.open(apiUrl.baseUrl + '/sales/delivery-order/pdf2/' + row.id, '_blank')
            },
            {
                title: "Hapus Delivery Order",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }

        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 180,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/sales/delivery-order/detail/' + id)}
                />
            ),
        },
    ];

    const ActionButtonsOutstanding = ({ row }: {
        row: any;
    }) => {
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Button
                    variant="contained"
                    color="success"
                    sx={{ mr: 1 }}
                    startIcon={<Icon icon="mdi:file-document-plus" />}
                    onClick={() => {
                        // navigate('/sales/delivery-order/add-so/' + row.id)
                        setSdsoD(row.so_id)
                        setValDoctag(null)
                        setOpenDialog(true)
                        setMode('all')
                    }}
                >
                    Buat DO Seluruhnya
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<Icon icon="mdi:file-document-plus" />}
                    onClick={() => {
                        // navigate('/sales/delivery-order/add-so/' + row.id)
                        setSdsoD(row.id)
                        setValDoctag(null)
                        setOpenDialog(true)
                        setMode('item')
                    }}
                >
                    Buat DO Per Item
                </Button>
            </Box>
        );
    };

    const actionOutstandingSo = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtonsOutstanding
                    row={row}
                />
            ),
        },
    ];

    const convertComponent = [
        {
            key: 'invoice',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {row.data.invoice == null ? (
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:file-document-plus" />}
                                onClick={() => {
                                    // navigate('/acc/invoice/add-do/' + row.id)

                                    setSddo(row.data.id)
                                    setValDoctagInv(null)
                                    setOpenDialogInv(true)
                                }}
                            >
                                Buat Invoice
                            </Button>
                        ) : (
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                                <div style={{ cursor: 'pointer' }} onClick={() => {
                                    window.open(`/acc/invoice/detail/${row.data.invoice}`, '_blank')
                                }}>
                                    <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
                                        {row.data.invoice}
                                    </Typography>
                                </div>
                            </Box>
                        )}
                    </Box>
                )
            }
        },
        {
            key: 'dp_id',
            minWidth: 160,
            renderCell: ({ row }: any) => {
                return (
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {row.data.dp_id == null ? (
                            <Button
                                variant="contained"
                                color="warning"
                                startIcon={<Icon icon="mdi:file-document-plus" />}
                                onClick={() => {
                                    setDialogMode('add-from-list')
                                    setSelectedData(row.data)
                                    setOpenDialogDP(true)
                                }}
                            >
                                Buat DP
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                color="success"
                                startIcon={<Icon icon="mdi:cash-fast" />}
                                onClick={() => {
                                    getDetail(row.data.dp_id)
                                }}
                            >
                                Bayar DP <br />
                                {row.data.dp_id}
                            </Button>
                        )}
                    </Box>
                )
            }
        },
    ];

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='DELIVERY ORDER' />
                        </Box>
                    </Box>
                    <Divider />
                    <CardContent>
                        <Grid
                            item
                            container
                            sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                            spacing={5}
                        >
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>
                                    <TextField
                                        label='Tanggal Awal'
                                        type='date'
                                        onChange={(e) => setTglAwal(e.target.value)}
                                        value={tglAwal}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth>

                                    <TextField
                                        label='Tanggal Akhir'
                                        type='date'
                                        onChange={(e) => setTglAkhir(e.target.value)}
                                        value={tglAkhir}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormControl fullWidth>
                                    <Button
                                        variant='contained'
                                        sx={{ mt: 1 }}
                                        startIcon={<Icon icon='mdi:magnify' />}
                                        onClick={() => getData(tabs)}
                                    >
                                        Cari Data
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                    <TabContext value={tabs}>
                        <TabList
                            scrollButtons
                            variant='scrollable'
                            onChange={handleChangeTabs}
                            aria-label='forced scroll tabs example'
                        >
                            <Tab value='0' label='Daftar Delivery Order' />
                            <Tab value='1' label='Delivery Order Belum Aktif' />
                            <Tab value='2' label='Outstanding Sales Order Belum Kirim' />
                        </TabList>
                        <TabPanel value='0'>
                            <MsiDatagrid array={listData} actions={actionData} customRender={convertComponent} hiddenColumns={['dokumen', 'sdcust_id', 'is_aktif', 'default_dp', 'default_dp_pesan']} />
                        </TabPanel>
                        <TabPanel value='1'>
                            <MsiDatagrid array={listData} actions={actionData} />
                        </TabPanel>
                        <TabPanel value='2'>
                            <MsiDatagrid array={listData} actions={actionOutstandingSo} />
                        </TabPanel>
                    </TabContext>
                </div>
            </Grid>

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Buat Delivery Order
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={3} component="form" onSubmit={(e) => {
                        e.preventDefault();
                        // Handle form submission

                        const payload = {
                            sdso_d_id: sdsoD,
                            sdso_id: sdsoD,
                            sysdoctag_id: valDoctag
                        }
                        let url = ''
                        if (mode == 'item') {
                            url = apiUrl.apiUrl + '/sales/delivery-order/add-do'
                        } else if (mode == 'all') {
                            url = apiUrl.apiUrl + '/sales/delivery-order/add-do-all'
                        }
                        axios
                            .post(url, payload, {
                                headers: { Authorization: `Bearer ${token}` }
                            })
                            .then(response => {
                                if (response.data.success) {
                                    const data = response.data.data[0]

                                    showToast(response.data.message, 'success');
                                    navigate('/sales/delivery-order/detail/' + data.id)
                                } else {
                                    showToast(response.data.message, 'error');
                                }
                            })
                            .catch(error => {
                                showToast(error.message, 'error');
                            })
                    }}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    label='Pilih Doctag'
                                    value={valDoctag}
                                    onChange={(e) => setValDoctag(e.target.value)}
                                >
                                    <MenuItem value="" disabled>Pilih Doctag</MenuItem>
                                    {listDoctag.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.nama}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant='contained' type='submit' disabled={!valDoctag} fullWidth>
                                Buat DO
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogInv}
                onClose={() => setOpenDialogInv(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Buat Invoice
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={3} component="form" onSubmit={(e) => {
                        e.preventDefault();
                        // Handle form submission

                        const payload = {
                            sddo_id: sddo,
                            sysdoctag_id: valDoctagInv,
                        }

                        const url = apiUrl.apiUrl + '/acc/invoice/add-invoice-from-do'
                        axios
                            .post(url, payload, {
                                headers: { Authorization: `Bearer ${token}` }
                            })
                            .then(response => {
                                if (response.data.success) {
                                    const data = response.data.data[0]

                                    showToast(response.data.message, 'success');
                                    navigate('/acc/invoice/detail/' + data.id)
                                } else {
                                    showToast(response.data.message, 'error');
                                }
                            })
                            .catch(error => {
                                showToast(error.message, 'error');
                            })
                    }}>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    label='Pilih Doctag'
                                    value={valDoctagInv}
                                    onChange={(e) => setValDoctagInv(e.target.value)}
                                >
                                    <MenuItem value="" disabled>Pilih Doctag</MenuItem>
                                    {listDoctagInv.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {item.nama}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant='contained' type='submit' disabled={!valDoctagInv} fullWidth>
                                Buat Invoice
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialogInv(false)}>Batal</Button>
                </DialogActions>
            </Dialog>

            <DialogDP
                key={selectedData?.id ?? 'add-from-list'}
                open={openDialogDP}
                mode={dialogMode}
                data={selectedData}
                doc_type={'sddo'}
                doc_id={selectedData?.id}
                onClose={() => {
                    setOpenDialogDP(false)
                    getData(tabs)
                }}
            />
        </Grid>
    )
}
